import { ETipoUsuario, normalizeTipoUsuario } from "domain/types";

const maintenanceFlagMap: Readonly<Record<ETipoUsuario, string>> = {
  [ETipoUsuario.ClienteFinal]: "underMaintenanceMgAppClienteFinal",
  [ETipoUsuario.Agenciero]: "underMaintenanceMgAppAgenciero",
  [ETipoUsuario.Interno]: "underMaintenanceMgAppInterno",
  [ETipoUsuario.Productor]: "underMaintenanceMgAppProductor",
  [ETipoUsuario.Gestor]: "underMaintenanceMgAppGestor",
  [ETipoUsuario.Vendedor]: "underMaintenanceMgAppVendedor",
  [ETipoUsuario.Supervisor]: "underMaintenanceMgAppSupervisor",
};

export const isUserTypeInMaintenance = (
  flags: Readonly<Record<string, unknown>>,
  userType: unknown,
): boolean => {
  const tipoUsuario = normalizeTipoUsuario(userType);

  if (!tipoUsuario) return false;

  return !!flags[maintenanceFlagMap[tipoUsuario]];
};
